<template>
  <div>
    <navigation />
    <topnav />
    <div class="addtask-container">
      <div class="addtask">
        <form v-on:submit.prevent="addTask">
          <div class="baseinfo">
            <p><span>一、填写基本信息</span></p>
            <div>
              <p>
                <span>任务名：</span>
                <input v-model="taskName" required maxlength="80" placeholder="请输入任务名，80字以内" />
              </p>
              <p>
                <span style="vertical-align: top;">任务描述：</span>
                <textarea v-model="desc" maxlength="500" placeholder="请输入任务描述，500字以内"></textarea>
              </p>
              <p>
                <span>行业：</span>
                <select v-model="industryId" required
                  ><option v-for="industry of industries" :key="industry.industryId" :value="industry.industryId">{{
                    industry.industryName
                  }}</option></select
                >
              </p>
              <p>
                <span>标注方式：</span>
                <select v-model="taskTypeId" required
                  ><option v-for="type of taskTypes" :key="type.taskTypeId" :value="type.taskTypeId">{{
                    type.taskTypeName
                  }}</option></select
                >
              </p>
            </div>
          </div>
          <div class="pathinfo">
            <p><span>二、添加图片存储路径</span></p>
            <div>
              <span>存储路径：</span>
              <input v-model="path" />
            </div>
          </div>
          <button type="submit">创建任务</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import navigation from '@/components/navigation';
import topnav from '@/components/topnav';

export default {
  data() {
    return {
      taskTypes: [],
      industries: [],
      industryId: 0,
      taskTypeId: 0,
      path: '',
      desc: '',
      taskName: '',
    };
  },
  components: {
    navigation,
    topnav,
  },
  mounted: function() {
    api
      .getTaskType()
      .then(res => {
        this.taskTypes = res.data.taskTypes;
      })
      .catch(() => {});
    api
      .getIndustry()
      .then(res => {
        this.industries = res.data.industries;
      })
      .catch(() => {});
  },
  methods: {
    addTask() {
      api
        .addTask({
          taskName: this.taskName,
          desc: this.desc,
          industryId: this.industryId,
          taskTypeId: this.taskTypeId,
          data: this.path,
        })
        .then(() => {
          this.$notify({
            group: 'foo',
            type: 'custom-blue',
            text: '创建任务成功',
            duration: 1500,
          });
          this.$store.commit('setKeepAlive', []);
          this.$router.push({ path: '/tasklist' });
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
p {
  margin: 0px;
}
span {
  vertical-align: baseline;
}
button {
  position: absolute;
  right: 50px;
  bottom: 36px;
  height: 38px;
  width: 88px;
}
select {
  width: 272px;
  height: 32px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background-image: url('~@/assets/select-arrow.png');
  background-repeat: no-repeat;
  background-position: right;
  background-position-x: 250px;
  background-size: 14px;
  color: #595959;
  padding: 7px 20px 7px 12px;
  font-size: 14px;
  line-height: 100%;
  background-color: #fff;
  margin-left: 6px;
}
input {
  box-sizing: border-box;
  height: 32px;
  width: 272px;
  margin-left: 6px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  font-size: 14px;
  padding: 0px 12px;
}
textarea {
  resize: none;
  min-height: 104px;
  width: 85%;
  box-sizing: border-box;
  margin-left: 6px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  font-size: 14px;
  padding: 9px 12px;
}
.addtask {
  position: relative;
}
.baseinfo {
  background: #fafafa;
  border-radius: 4px 4px 0px 0px;
  margin: 24px 0px 12px;
  padding: 24px 36px;
  box-sizing: border-box;
}
.baseinfo div {
  margin-top: 24px;
}
.baseinfo div p {
  margin: 16px 0px;
}
.addtask div div p span {
  width: 80px;
  display: inline-block;
}
.pathinfo {
  background: #fafafa;
  border-radius: 4px 4px 0px 0px;
  margin: 0px;
  padding: 36px;
}
.pathinfo div {
  margin: 16px 50px 62px 0px;
}
.addtask-container {
  padding: 84px 50px 0px 301px;
}
</style>
